import { plainToClass } from "class-transformer";
import { toJS } from "mobx";
import ChargeOrder from "models/chargeOrder";

export default function (chargeOrder: ChargeOrder): ChargeOrder {
  return plainToClass(ChargeOrder, {
    ...chargeOrder,
    charges: [...toJS(chargeOrder.charges)],
    notificationPreferences: { ...chargeOrder.notificationPreferences },
  });
}
